import MUIWarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useContext } from "react";

import MUIBox from "@mui/material/Box";
import MUIAlert from "@mui/material/Alert";

import { ChartContext } from "../../../Context/ChartContext/ChartContext";

/**
 * Display a list of violations.
 * @returns {JSX.Element|null}
 */

const title = "Violations";
const icon = MUIWarningAmberIcon;
const className = "CardChartViolations";

export default function CardChartViolations() {
    const chartContext = useContext(ChartContext);

    return (
        <MUIBox sx={{ pb: 2 }}>
            <MUIAlert severity="error" variant="filled">
                {Object.entries(chartContext.ruleViolations).map(([key, violation]) => (
                    <div key={key}>
                        {violation.message}
                    </div>
                ))}
            </MUIAlert>
        </MUIBox>
    );
}

CardChartViolations.meta = { className: className, title: title, icon: icon, showInNavigation: false };
